export const VendorAttachmentsTypes = {
  gst: "gst",
  msme: "msme",
  common: "common",
};
